// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__2evQM","errors":"Errors_errors__2QNdq"};